'use client'
import {createContext} from "react";
import {useContextStrict} from "@web-libs/core/context/context.functions";
import {DictionaryEntries} from "@web-libs/core/internationalization/dictionary.types";

export const DictionaryContext = createContext<DictionaryEntries |null>(null)

export const useDictionaryContext = () => useContextStrict(DictionaryContext)
